import { useState } from 'react'
import axios from 'axios'
import {
    GetEncryptedString,
    GetDecryptedString,
    GetDecryptedObject,
    GetEncryptObject,
} from '../functionTool/encryption'
import { SessionClear, getToken } from '../functionTool/functionTool'

const GetInitUser = () => {
    const userName = window.localStorage.getItem('userName')
    const menuList = GetDecryptedObject(window.localStorage.getItem('menuList'));
    const token = GetDecryptedString(window.localStorage.getItem('token'))
    const roleList = GetDecryptedObject(window.localStorage.getItem('roleList'))

    if (userName && token) {
        return {
            userName,
            menuList: menuList || [],
            token,
            roleList,
        }
    } else {
        return null
    }
}

const useAuth = () => {
    const [user, setUser] = useState(GetInitUser())

    const AuthUser = (authUser) => {
        if (authUser) {
            authUser.token = 'Bearer ' + authUser.token
            window.localStorage.setItem('userName', authUser.userName)
            window.localStorage.setItem('menuList', GetEncryptObject(authUser.menuList))
            window.localStorage.setItem('roleList', GetEncryptObject(authUser.roleList))
            window.localStorage.setItem(
                'token',
                GetEncryptedString(authUser.token)
            )
            setUser(authUser)
        }
    }
    const UnAuthUser = async () => {
        try {
            const token = getToken()
            if (token) {
                await axios.post(
                    `${process.env.REACT_APP_APIGATEWAY_URL}/auth/logout`,
                    {},
                    { headers: { Authorization: token }, withCredentials: true }
                )
            }
        } catch (e) {
            console.error('Logout API error:', e)
        } finally {
            SessionClear()
            setUser(null)
        }
    }

    return { user, AuthUser, UnAuthUser }
}
export default useAuth
